import { gojsCommentCursor } from '../../../assets/cursors';
import { sidebarNodeTypes } from '../../../config/config';
import { getApiForNodeType } from '../../common/api/api-map';
import { BaseApi } from '../../common/api/base-api.interface';
import { deleteAPI } from '../../common/api/delete-api';
import { PinNodeCreateProps } from '../models/pin-node-create-props';
import { PinNodeTemplateProps } from './../models/pin-node-template-props';
import { createPinNode } from './create-pin-node';
import { setupPinNode } from './setup-pin-node';

export const pinNodeAPI = (): BaseApi<PinNodeCreateProps, PinNodeTemplateProps> => ({
  name: sidebarNodeTypes.pinNode,
  setup: setupPinNode,
  create: createPinNode,
  getCursor: () => gojsCommentCursor,
  delete: deleteAPI,
  ...getApiForNodeType(sidebarNodeTypes.pinNode),
});
